<template>
  <div class="object-copy-photo">
    <div v-if="object">
      <el-table
        ref="objectCopyPhotoTable"
        :data="tableData"
        v-loading="loading"
        stripe
        style="width: 100%;"
        @selection-change="selection"
      >
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column
          prop="url"
          width="100"
          align="center"
          :label="$t('copy_file_table_photo')"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 68px;"
              :src="scope.row.url"
              :preview-src-list="[scope.row.url]"
            >
            </el-image>
          </template>
        </el-table-column>

        <el-table-column
          prop="description"
          :label="$t('copy_file_table_description')"
        ></el-table-column>

        <el-table-column
          prop="fileName"
          :label="$t('copy_file_table_file_name')"
        >
          <template slot-scope="scope">
            <div
              :class="{
                'object-copy-photo__control_dublicate': isDublicateName(
                  scope.row
                )
              }"
            >
              <el-input v-model="scope.row.fileName">
                <template slot="append">{{ scope.row.fileExt }}</template>
              </el-input>
            </div>
            <span v-if="isDublicateName(scope.row)">
              {{ $t("copy_file_table_file_name_rule") }}
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div class="object-copy-photo__actions">
        <el-button @click="cancel">
          {{ $t("copy_file_action_cancel") }}
        </el-button>

        <el-button type="success" :disabled="copyDisabled" @click="copy">
          {{ $t("copy_file_action_copy") }}
        </el-button>
      </div>
    </div>
    <div v-else>
      <copy-object-instruction />
    </div>
  </div>
</template>

<script>
import CopyObjectInstruction from "@/components/common.blocks/information/CopyObjectInstruction.vue";

import { mapState } from "vuex";

import * as galleryService from "@/domain/object/gallery.service";
import { clone } from "@/domain/system/utils";

export default {
  name: "ObjectCopyPhoto",
  props: {
    object: Object,
    loading: Boolean,
    usedNames: Array
  },
  data() {
    return {
      tableData: [],
      multipleSelection: []
    };
  },
  components: {
    CopyObjectInstruction
  },
  computed: {
    ...mapState({
      currentLanguage: state => state.objectSetting.currentLanguage
    }),
    gallery() {
      return galleryService.getGalleryListFromObject(this.object);
    },
    copyDisabled() {
      return (
        this.multipleSelection.length === 0 ||
        this.tableData.some(t => this.isDublicateName(t))
      );
    },
    usedNamesLower() {
      return this.usedNames.map(t => t.toLowerCase());
    }
  },
  methods: {
    async setGalleryList() {
      this.tableData = [];
      galleryService
        .getGalleryListFromObject(this.object, this.currentLanguage)
        .forEach(g => {
          this.tableData.push(clone(g));
        });
    },
    cancel() {
      this.$emit("cancel");
    },
    copy() {
      this.$emit(
        "copy",
        galleryService.getSelectedFileForCopy(this.multipleSelection)
      );
      this.multipleSelection = [];
      this.$refs.objectCopyPhotoTable.clearSelection();
    },
    selection(val) {
      this.multipleSelection = val;
    },
    selectionNameDublicate() {
      let i, j;
      let result = [];
      let selectedName = this.multipleSelection.map(t =>
        `${t.fileName}.${t.fileExt}`.toLowerCase()
      );
      for (i = 0; i < selectedName.length - 1; i++) {
        for (j = i + 1; j < selectedName.length; j++) {
          if (selectedName[i] === selectedName[j]) {
            result.push(selectedName[i]);
            break;
          }
        }
      }
      return result;
    },
    isDublicateName(item) {
      if (this.multipleSelection.some(t => t.url === item.url)) {
        let name = `${item.fileName}.${item.fileExt}`.toLowerCase();
        return (
          !item.fileName ||
          this.usedNamesLower.some(t => t === name) ||
          this.selectionNameDublicate().some(t => t === name)
        );
      }
      return false;
    }
  },
  mounted() {
    this.setGalleryList();
  },
  watch: {
    object: function () {
      this.setGalleryList();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/variables.scss";

.object-copy-photo {
  padding: $component_padding_on_top $component_padding_on_left;
  overflow: auto;
  height: calc(100% - 30px);

  .object-copy-photo__actions {
    position: sticky;
    bottom: -5px;
    margin-top: 10px;
    padding: 10px 0;
    text-align: right;
    width: 100%;
    background-color: $free_zone_color;
    z-index: 4;
  }

  .object-copy-photo__control_dublicate {
    border: 1px solid $danger_color;
    border-radius: 4px;
  }
}
</style>
